export enum ModuleNames {
    HOME = 'home',
    USERS = 'users',
    ADMINS = 'admins',
    PARTNERS = 'partners',
    PARTNER_EARNINGS = 'partner_earnings',
    TRANSACTIONS = 'transactions',
    ADS_MANAGEMENT = 'ads_m',
    NEWS_AND_EVENTS = 'news_and_events_m',
    NOTIFICATION = 'notification_m',
    COUPONS = 'coupons_m',
    PRICING = 'pricing_m',
    WITHDRAWAL_CMS = 'withdrawal_cms_m',
    REWARDS_CMS = 'rewards_cms_m',
    VEHICLE_CMS = 'vehicle_cms_m',
    LOCATION_CMS = 'location_cms_m',
    SURGE_CMS = 'surge_cms',
    SERVICE_FEE_CMS = 'service_fee_cms_m',
    FLEET_FEE_DISTRIBUTION_CMS = 'fleet_fee_distribution_cms_m',
    RIDE_CONFIG_CMS = 'ride_config_cms_m',
    SERVICES_CMS = 'services_cms_m',
    PAYMENT_METHODS_CMS = 'payment_methods_cms_m',
    TOPUPS = 'm_top_ups',
    COMCENTER_OVERVIEW = 'comcenter_overview',
    COMCENTER_EXPRESS = 'comcenter_express',
    COMCENTER_RIDE = 'comcenter_ride',
    COMCENTER_MOTAXI = 'comcenter_motaxi',
    COMCENTER_RT_MAP = 'comcenter_rt_map',
}
